<div class="automation-field">
  <label [attr.for]="name">{{ label }}</label>

  <!---- <div class="field-type-toggle">
    <button type="button" class="btn f-13" [class.active]="isValue" (click)="setFieldType('Value')">Value</button>
    <button type="button" class="btn f-13" [class.active]="isReference"
      (click)="setFieldType('Reference')">Reference</button>
    <button type="button" class="btn f-13" [class.active]="isTemplate"
      (click)="setFieldType('Template')">Template</button>
  </div>-->


  <div class="input-group mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" style="line-height: 0.9!important;" id="basic-addon1">
        <div class="dropdown">
          <button class="dropdown-toggle border-0 f-13" style="background-color: transparent!important;" type="button"
            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <ng-container *ngIf="isValue">
              Value
            </ng-container>
            <ng-container *ngIf="isReference">
              Reference
            </ng-container>
            <ng-container *ngIf="isTemplate">
              Template
            </ng-container>
          </button>
          <div class="dropdown-menu cursor-pointer" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item f-13" (click)="setFieldType('Value')">Value</a>
            <a class="dropdown-item f-13" (click)="setFieldType('Reference')">Reference</a>
            <a class="dropdown-item f-13" (click)="setFieldType('Template')">Template</a>
          </div>
        </div>
      </span>
    </div>

    <ng-container *ngIf="isValue && options?.length > 0">
      <select class="form-control" [formControl]="valueControl">
        <option *ngFor="let opt of options" [value]="opt.value">{{ opt.label }}</option>
      </select>
    </ng-container>

    <ng-container *ngIf="isValue && !options?.length">
      <input class="form-control" type="text" [formControl]="valueControl" [placeholder]="placeholder" />
    </ng-container>

    <ng-container *ngIf="isReference">
      <mat-form-field appearance="outline" style="height:35px; flex: auto;">
        <mat-label>{{ label }}</mat-label>
        <input type="text" style="vertical-align: -webkit-baseline-middle;" matInput class="form-control"
          [formControl]="valueControl" [matAutocomplete]="auto" (input)="filterPaths(valueControl.value)"
          [placeholder]="placeholder || 'e.g. automationData.lastrun.project.name'" aria-label="Reference" />
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let path of filteredPaths" [value]="path">
            {{ path }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="isTemplate">
      <textarea rows="2" class="form-control" [formControl]="valueControl"
        [placeholder]="placeholder || 'e.g. Project {{automationData.lastrun.project.name}}'"></textarea>
    </ng-container>
  </div>


  <!-- Value Input 
  <div *ngIf="isValue">
    <select *ngIf="options?.length > 0" class="form-control" [formControl]="valueControl">
      <option *ngFor="let opt of options" [value]="opt.value">{{ opt.label }}</option>
    </select>
    <input *ngIf="!options?.length" class="form-control" type="text" [formControl]="valueControl"
      [placeholder]="placeholder" />
  </div>-->

  <!-- Reference Input with Autocomplete 
  <div *ngIf="isReference">
    <mat-form-field appearance="outline" style="width: 100%; height:55px;">
      <mat-label>{{ label }}</mat-label>
      <input type="text" matInput class="form-control" [formControl]="valueControl" [matAutocomplete]="auto"
        (input)="filterPaths(valueControl.value)"
        [placeholder]="placeholder || 'e.g. automationData.lastrun.project.name'" aria-label="Reference" />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let path of filteredPaths" [value]="path">
          {{ path }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>-->


  <!-- Template Input 
  <div *ngIf="isTemplate">
    <textarea rows="2" class="form-control" [formControl]="valueControl"
      [placeholder]="placeholder || 'e.g. Project {{automationData.lastrun.project.name}}'"></textarea>
  </div> -->

  <small class="helper-text" *ngIf="helperText">{{ helperText }}</small>
</div>